import React, { ReactElement } from 'react';
import Description from './Description';
import About from './About';
import Office from './Office';
import Map from '../../Map';

const Home: React.FC = (): ReactElement => {
  return (
    <div className="relative flex flex-grow flex-col overflow-auto scroll-smooth">
      <Description />
      <About />
      <Office />
      <Map />
    </div>
  );
};

export default Home;
